import { adminRolesAPI } from 'api/admin-roles';
import { AdminRoleDto } from 'dto/admin-roles';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: AdminRoleDto) => void;
};

export function useFindOneAdminRole(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_ADMIN_ROLE, props.id],
    queryFn: () => adminRolesAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
